import { render, staticRenderFns } from "./GameProfileNav.vue?vue&type=template&id=44b210bc&lang=pug"
import script from "./GameProfileNav.vue?vue&type=script&lang=js"
export * from "./GameProfileNav.vue?vue&type=script&lang=js"
import style0 from "./GameProfileNav.vue?vue&type=style&index=0&id=44b210bc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports